/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, enableProdMode, HostListener, OnInit} from '@angular/core';
import {AnalyticsService} from './@core/utils/analytics.service';
import {SeoService} from './@core/utils/seo.service';
import {NbIconLibraries, NbThemeService} from '@nebular/theme';
import {Title} from '@angular/platform-browser';
import {environment} from '../environments/environment';
import {UtilsService} from './@core/services/util/utils.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'ngx-app',
  template: `<div class="d-flex flex-column justify-content-center align-items-center" id="customSpinner" *ngIf="spinnerActive">
    <div class="close-spinner pointer" (click)="closeSpinner()">
      <i class="fas fa-times"></i>
    </div>
    <div class="spinner-border text-primary" role="status"></div>
    <div class="spinner-title mt-3">{{spinnerTitle}}</div>
  </div>
  <ng-container *ngIf="showComponent">
    <router-outlet></router-outlet>
  </ng-container>
  <select (change)="changeLanguage($event)" style="position: fixed; bottom: 10px; right: 10px;" *ngIf="showLangSwitcher">
    <option value="de">de</option>
    <option value="en">en</option>
  </select>`,
})
export class AppComponent implements OnInit {

  public showLangSwitcher = false;
  public spinnerActive: boolean = false;
  public spinnerTitle: string = '';
  public showComponent: boolean = true;
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private themeService: NbThemeService,
    private iconLibraries: NbIconLibraries,
    private titleService: Title,
    private utilsService: UtilsService,
    private translate: TranslateService
  ) {
    enableProdMode();
    this.languageSetup();
    this.titleService.setTitle(environment.title);
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fas', iconClassPrefix: 'fa' });
    this.iconLibraries.registerFontPack('font-awesome-fab', { packClass: 'fab', iconClassPrefix: 'fa' });
    this.iconLibraries.setDefaultPack('font-awesome');
    if(localStorage.getItem('currentTheme') == 'dark' || localStorage.getItem('currentTheme') == 'default'){
      this.themeService.changeTheme(localStorage.getItem('currentTheme'));
    }
    this.utilsService.spinnerEvent.subscribe((res: boolean) => {
      this.spinnerTitle = this.utilsService.spinnerTitle;
      if(res){
        document.getElementsByTagName('body')[0].classList.add('overflow-hidden');
      }else{
        document.getElementsByTagName('body')[0].classList.remove('overflow-hidden');
      }
      this.spinnerActive = res;
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
  }

  public closeSpinner(): void {
    this.utilsService.stopSpinner();
  }

  private languageSetup(): void {
    if(location.origin.includes("://localhost:")){
      this.showLangSwitcher = true;
    }


    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('en');

    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/de|en/) ? browserLang : 'en');
  }

  public changeLanguage(lang: any): void {
    this.translate.use(lang.target.value);
    this.showComponent = false;
    setTimeout(() => this.showComponent = true, 0);
  }

  @HostListener('click')
  public clearTooltipOnClick() {
    let tooltips = document.querySelectorAll('body > .tooltip.tableTooltip');
    for(let i = 0; i < tooltips.length; i++){
      tooltips.item(i).remove();
    }
  }
}
